import React from 'react';

export default function ({data}) {
  return (
    <div className='calloutData'>
      <p>I am:</p>
      <ul>
        {
          data.map(item => {
            return (<li>{item}</li>)
          })
      }
      </ul>
    </div>
  )
}
